import { DONOTCALLDATA, CONTACTDATA, FETCH, FETCH2 } from './actionType'

// initialState shows what we are going to change
const initialState = {
  data: null,
  // API call
  fetching: false,
  fetching2: false,
}

// Checks the type of the action and returns the appropriate state
export default function doNotCallCreateReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH:
      // Boolean describing if the data is being gathered
      return Object.assign({}, state, {
        fetching: action.fetching,
      })
    case FETCH2:
      // Boolean describing if the data is being gathered
      return Object.assign({}, state, {
        fetching: action.fetching2,
      })
    case DONOTCALLDATA:
      // Populate DNC calling list
      return Object.assign({}, state, {
        data: action.data,
      })
    case CONTACTDATA:
      // Update to DNC List, either add or remove
      return Object.assign({}, state, {
        data: action.data,
      })
    default:
      // returns state as is without changes
      return state
  }
}
